import React from "react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const realEstateData = {
  badge: "PropTech AI",
  title: "Real Estate AI Platform",
  industry: "Real Estate",
  tagline: "Qualify more leads, book more site visits, and close more deals with 24/7 AI agents.",
  image: "https://images.pexels.com/photos/3137050/pexels-photo-3137050.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  cta: "Explore PropTech Platform",
  stats: [
    { number: "3x", label: "More Qualified Site Visits" },
    { number: "50%", label: "Higher Conversion Rate" },
    { number: "24/7", label: "Lead Qualification" },
    { number: "80%", label: "Faster Response Time" },
  ],
  problems: [
    {
      title: "Lead Qualification Bottlenecks",
      desc: "Sales teams waste time on unqualified leads while hot prospects go cold waiting for a response.",
    },
    {
      title: "Property Inquiry Overflow",
      desc: "High inquiry volumes from portals overwhelm the team — many leads never receive a response.",
    },
    {
      title: "Site Visit Booking Friction",
      desc: "Manual coordination of site visits leads to missed opportunities and scheduling conflicts.",
    },
    {
      title: "Follow-Up Automation Gaps",
      desc: "Inconsistent follow-up via calls and messages means deals fall through at every stage.",
    },
  ],
  solutions: [
    {
      title: "AI Voice Agents for Leads",
      desc: "Human-like voice agents that call, qualify, and book site visits for every incoming lead automatically.",
    },
    {
      title: "WhatsApp Sales Automation",
      desc: "Automated WhatsApp sequences that nurture leads, share property details, and book appointments.",
    },
    {
      title: "Lead Qualification AI Agents",
      desc: "Intelligent scoring and routing system that identifies high-intent buyers and escalates to sales teams.",
    },
    {
      title: "End-to-End Sales Automation",
      desc: "Automated pipeline management from first inquiry to site visit to CRM update — zero manual work.",
    },
  ],
  outcome:
    "Generate 3x more qualified site visits and increase conversion rates by 50% through 24/7 AI-powered lead engagement. Every lead is contacted within seconds, qualified automatically, and handed to your sales team ready to close.",
};

const RealEstatePage = () => <IndustryPageTemplate data={realEstateData} />;

export default RealEstatePage;
